import { canUseDom } from '../utils/can-use-dom';
import "./global.css";

if (canUseDom) {
  // 使 ios 设备支持 :active 样式
  // @see https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/AdjustingtheTextSize/AdjustingtheTextSize.html
  document.addEventListener('touchstart', function () {}, true);
}